
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"6","y":"9","width":"21","height":"3","rx":"1.5"}}),_c('rect',{attrs:{"x":"9","y":"14.25","width":"14","height":"3","rx":"1.5"}}),_c('rect',{attrs:{"x":"13","y":"19.5","width":"7","height":"3","rx":"1.5"}})])
          )
        }
      }
    